function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  stroke: "#1CA6FF",
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1CA6FF"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#1CA6FF",
  strokeWidth: 0.979,
  d: "M22.485 13.44c-3.132 0-5.75 2.302-6.284 5.328-2.809.253-5.017 2.62-5.017 5.53 0 3.078 2.466 5.575 5.506 5.575h2.608c.092.002.342-.267.353-.524.013-.323-.237-.651-.353-.65H16.69c-2.418 0-4.347-1.953-4.347-4.401 0-2.449 1.929-4.402 4.347-4.402.3.001.551-.23.58-.532.262-2.665 2.506-4.75 5.215-4.75 1.475 0 2.682.578 3.64 1.577a.574.574 0 0 0 .625.138c.419-.161 1.015-.248 1.53-.248a4.084 4.084 0 0 1 4.057 3.586c.025.222.173.41.38.486 1.657.615 2.808 2.229 2.808 4.145 0 2.448-1.929 4.402-4.347 4.402h-2.287c-.11-.002-.366.339-.36.65.006.275.262.525.36.523h2.287c3.04 0 5.506-2.497 5.506-5.575a5.54 5.54 0 0 0-3.25-5.071c-.447-2.467-2.602-4.32-5.153-4.32a5.79 5.79 0 0 0-1.594.239c-1.116-1.048-2.545-1.706-4.202-1.706z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.346 36.347l3.332-2.77a.53.53 0 0 0-.34-.937h-6.597a.53.53 0 0 0-.342.934l3.265 2.77a.53.53 0 0 0 .682.003z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.652 33.707h.984a.564.564 0 0 0 .564-.564v-7.447a1.056 1.056 0 1 0-2.112 0v7.447c0 .311.253.564.564.564z"
})));

const SvgIcCloudBackup = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloudBackup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cloud-backup.e078c9d3.svg";
export { ForwardRef as ReactComponent };